<template>
  <div class="page landing">
    <!-- banner -->
    <section class="banner"></section>

    <section class="content">
      <!-- 标语 -->
      <div class="slogan">拒绝高利贷，拒绝砍头息</div>

      <!-- 表单内容 -->
      <form ref="form" class="form">
        <div class="form-item">
          <nd-input
            name="mobile"
            v-model="form.mobile"
            placeholder="输入手机号，立马借款"
            type="pure-number"
            maxLength="11"
            @blur="mobileBlur"
          >
          </nd-input>
        </div>

        <div class="form-item">
          <nd-input
            name="smsCode"
            v-model="form.smsCode"
            placeholder="请输入验证码"
            type="pure-number"
            maxLength="6"
            @blur="codeBlur"
          >
          </nd-input>

          <nd-send-code
            class="send-code"
            :disabled="smsDisabled"
            :sendCode="sendCodeHandler"
          />
        </div>
        <div class="agree" @click="protocolPopup = true">
          点击「立即借款」按钮即表示您已阅读并同意
          <span class="highlight">用户服务协议</span>
        </div>
        <div class="btn" @click="goLoan">立即借款</div>
      </form>

      <!-- 特色 -->
      <div class="property">
        <div class="property-item">
          <div class="item-icon">
            <img src="https://static.ndmicro.com/tmd/landing/images/001.png" />
          </div>

          <div class="item-content">
            <div>快速审批</div>
            <div>最快5分钟放款</div>
          </div>
        </div>
        <div class="property-item">
          <div class="item-icon">
            <img src="https://static.ndmicro.com/tmd/landing/images/002.png" />
          </div>

          <div class="item-content">
            <div>分期偿还</div>
            <div>可分12期偿还</div>
          </div>
        </div>
        <div class="property-item">
          <div class="item-icon">
            <img src="https://static.ndmicro.com/tmd/landing/images/003.png" />
          </div>

          <div class="item-content">
            <div>放心使用</div>
            <div>正规持牌机构</div>
          </div>
        </div>
      </div>

      <!-- 公司信息 -->
      <section class="company">
        <p class="main">重庆市崇天小额贷款有限公司</p>
        <p>公司地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室</p>
        <p>联系电话：400-010-0008</p>
      </section>
    </section>

    <!-- 图片验证码弹窗 -->
    <nd-dialog
      v-model="captchaVisible"
      class="captcha-dialog"
      :footer="false"
      closeBtn
    >
      <div class="captcha-dialog-content">
        <div class="captcha-title">请输入下面的图形验证码</div>

        <div
          class="captcha-image"
          ref="canvasWrapper"
          @click="createImage"
        >
          <canvas ref="canvas"></canvas>
        </div>

        <nd-input
          class="captcha-input"
          v-model="imageCode"
          maxLength="4"
          type="number"
          placeholder=" "
        ></nd-input>

        <nd-button
          class="captcha-btn"
          :disabled="imageCode.length < 4"
          @click="verifyCode"
        >提交</nd-button>
      </div>
    </nd-dialog>

    <van-popup
      v-model="protocolPopup"
      class="protocol-popup"
      position="bottom"
    >
      <dl>
        <dt>
          用户服务协议
          <img
            src="https://static.ndmicro.com/tmd/landing/images/btn_close.png"
            srcset="
                            https://static.ndmicro.com/tmd/landing/images/btn_close@2x.png 2x,
                            https://static.ndmicro.com/tmd/landing/images/btn_close@3x.png 3x
                        "
            @click="protocolPopup = false"
          />
        </dt>
        <dd tag="dd" v-for="(item, index) in protocols" :key="index" @click="routerToProtocol(item.path)">
          {{item.name}}
        </dd>
      </dl>
    </van-popup>

    <!-- 下载引导 -->
    <download-guide ref="downloadGuide"></download-guide>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import validate from '../../../components/nd-validate'
import DownloadGuide from '../../authentication/components/download-guide'
import { Popup } from 'vant'
import axios from '@/assets/axios'

export default {
  name: 'landingActivityA',

  mixins: [validate],

  components: {
    DownloadGuide,
    Popup
  },

  data () {
    return {
      form: {
        mobile: '',
        smsCode: '',
        smsKey: ''
      },
      captchaVisible: false,
      rules: {
        mobile: [
          {
            require: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            regular: /^1[0-9]{10}$/,
            message: '手机号码格式错误，请重新输入',
            trigger: 'blur'
          }
        ],
        smsCode: [
          {
            require: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            regular: /[0-9]{6}$/,
            message: '验证码错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      channel: '',
      popupTime: 0,
      imageCode: '',
      randomArray: [],
      context: null,
      protocolPopup: false,
      protocols: [{ name: '《崇天用户注册及服务协议》', path: '/protocol/login' }, { name: '《崇天隐私政策》', path: '/protocol/privacy' }, { name: '《天美贷用户注册及服务协议》', path: '/tmd/protocol/login' }, { name: '《天美贷隐私政策》', path: '/tmd/protocol/privacy' }],
      nextNode: 'CREDIT_RESULT',
      loanList: null,
      serialNo: null,
      half: false
    }
  },

  created () {
    // 获取落地页渠道
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
  },

  computed: {
    smsDisabled () {
      return !this.validateWithoutTip({ mobile: this.rules.mobile })
    },

    ...mapState('user', {
      authStatus: (state) => state.userInfo.authStatus || []
    })
  },

  methods: {
    ...mapActions('user', ['sendCodeX', 'loginBySmsX', 'getUserInfoX']),

    randomNumber (num) {
      var random = ''
      for (var i = 0; i < num; i++) {
        random += Math.floor(Math.random() * 10)
      }
      return random
    },

    // 点击获取验证码
    sendCodeHandler () {
      this.$report({
        id: 50018,
        args: {
          status: 'A',
          target: 'PAY_IF_REFUSE'
        }
      })
      return new Promise((resolve, reject) => {
        this.popupTime = new Date().getTime()
        this.$report({
          id: 50020,
          args: {
            visible: 1,
            status: 'A',
            target: 'PAY_IF_REFUSE'
          }
        })
        this.captchaVisible = true
        this.createImage()
        this.imageCode = ''
        this.$once('captcha-passed', async () => {
          const response = await this.sendCodeX({
            mobile: this.form.mobile
          })
          if (response.success) {
            this.form.smsKey = response.data.smsKey
            resolve(true)
          } else {
            reject(new Error(response.msg))
          }
        })
      })
    },

    // 校验验证码
    verifyCode () {
      this.$indicator()
      setTimeout(() => {
        this.$indicator.close()
        if (this.imageCode === this.random) {
          this.$report({
            id: 50020,
            args: {
              visible: 0,
              status: 'A',
              target: 'PAY_IF_REFUSE'
            }
          })
          this.captchaVisible = false
          this.$emit('captcha-passed')
        } else {
          this.$message('验证码错误')
        }
      }, 500)
    },

    createImage () {
      this.random = this.randomNumber(4)
      const ctx = this.$refs['canvas'].getContext('2d')
      ctx.clearRect(0, 0, 300, 400)
      this.$nextTick(() => {
        ctx.fillStyle = '#FF4633'
        ctx.textBaseline = 'middle'
        ctx.font = '88px DIN-Medium'

        ctx.fillText(this.random, 48, 80)
      })
    },

    // 立即借款
    async goLoan () {
      const res = this.validateWithoutTip(this.rules, (msg) =>
        this.$message(msg)
      )
      if (!res) return
      this.$report({
        id: 50019,
        args: {
          status: 'A',
          target: 'PAY_IF_REFUSE'
        }
      })
      const response = await this.loginBySmsX(this.form)
      if (response.success) {
        this.$statistics('LOGIN')
        await this.getUserInfoX({ forceUpdate: true, checkToken: true })
        await this.getProcessType()
        this.nextStep()
      } else {
        if (response.code === '000010') {
          this.$message(response.msg)
        }
      }
    },

    mobileBlur () {
      this.$report({
        id: 50016,
        args: {
          content: this.form.mobile,
          status: 'A',
          target: 'PAY_IF_REFUSE'
        }
      })
    },

    codeBlur () {
      this.$report({
        id: 50017,
        args: {
          content: this.form.smsCode,
          status: 'A',
          target: 'PAY_IF_REFUSE'
        }
      })
    },

    // 判断用户下一步走什么流程
    async nextStep () {
      // 判断OCR
      if (this.nextNode === 'CERTIFICATION') {
        return this.$router.push('/authentication/id?pfrom=landing')
      }

      // 如果OCR过期
      if (this.nextNode === 'BASE') {
        return this.$router.push('/authentication/base?pfrom=landing')
      }

      // 判断基本信息
      if (this.nextNode === 'CREDIT_RESULT') {
        if (!this.half && !this.serialNo) {
          return this.$router.push('/')
        }
        return this.$router.push(`/authentication/result?pfrom=landing&channel=${this.channel}`)
      }

      // 如果都做过则直接走引导下载流程
      // this.startLeading()
    },

    // 开始引导
    async startLeading () {
      this.downloadApp()
    },
    async getProcessType () {
      const res = await axios.post('/order/v1/biz-route', {
        channelNo: this.channel
      })
      if (res.data.success) {
        this.nextNode = res.data.data.currentNode
        this.loanList = res.data.data.loanList
        this.serialNo = res.data.data.serialNo
        this.half = res.data.data.half
      }
    }
  }
}
</script>
<style lang="less">
@import "../../../assets/less/mixin.less";

.page.landing {
    .banner {
        width: 750px;
        height: 922px;
        margin: 0 auto;
        background-image: url(https://static.ndmicro.com/tmd/landing/rejectpay/images/banner_a.png);
        background-size: cover;
    }

    .content {
        background-color: #FFEDE8;
        padding-top: 74px;
        width: 750px;
        margin: 0 auto;
        height: unset;
        position: relative;
        top: -2px;

        .slogan {
            position: relative;
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: bold;
            font-family: PingFangSC-Regular;
            text-align: center;
            color: @fc2;

            &::before,
            &::after {
                content: '';
                position: absolute;
                top: 50%;
                margin-top: -1px;
                width: 113px;
                height: 2px;
                background-color: #FFD0C3;
            }

            &::before {
                left: 63px;
            }

            &::after {
                right: 63px;
            }
        }

        .form {
            margin: 0 auto;
            width: 656px;
            margin-top: 60px;

            .form-item {
                margin: 0 auto;
                width: 625px;
                height: 94px;
                line-height: 94px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                border-radius: 10px;
                background-color: #ffffff;
                padding: 0 15px 0 30px;
                margin-top: 21px;
                font-size: 33px;
                font-family: PingFang SC;
                font-weight: 400;

                .nd-input {
                    input {
                        font-size: 33px;
                        height: 50px;
                        line-height: 50px;
                    }
                }

                .form-tip.visible {
                    color: transparent;
                    opacity: 0;
                }

                .send-code {
                    height: 61px;
                    line-height: 61px;
                    width: 183px;
                    border: 1px solid #ff4633;
                    color: #ff4633;
                    background-color: white;
                    border-radius: 31px;
                    font-size: 27px;
                    flex-shrink: 0;

                    span {
                        font-size: 27px;
                    }

                    &.disabled {
                        color: @fc4;
                        border: 1px solid @fc4;
                    }
                }
            }

            .agree {
                margin: 54px 30px 0;
                font-size: 22px;
                font-family: PingFang SC;
                font-weight: 300;
                color: @fc2;
                .highlight {
                    color: #FF4633;
                }
            }

            .btn {
                width: 521px;
                height: 103px;
                background-image: url(https://static.ndmicro.com/tmd/landing/rejectpay/images/btn_a.png);
                background-size: 100% 100%;
                font-size: 40px;
                font-family: PingFang SC;
                font-weight: 600;
                color: white;
                text-align: center;
                line-height: 105px;
                margin: 0 auto;
                margin-top: 25px;
            }
        }

        .property {
            display: flex;
            margin: 60px auto 0;
            padding-bottom: 75px;

            .property-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;

                .item-icon {
                    width: 120px;
                    height: 120px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .item-content {
                    :first-child {
                        font-size: 29px;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        color: @fc1;
                    }
                    :last-child {
                        font-size: 23px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        color: @fc3;
                    }
                }
            }
        }
    }

    .company {
        height: 160px;
        width: 750px;
        margin: 0 auto;
        background-color: #F3A78F;
        padding: 0 30px;
        color: #FFFFFF;
        font-size: 23px;
        font-family: PingFang SC;
        font-weight: 400;
        overflow: hidden;
        box-sizing: border-box;

        p {
            line-height: 1.6em;
        }

        .main {
            font-size: 27px;
            margin-top: 25px;
        }
    }

    .captcha-dialog-content {
        padding-bottom: 73px;

        .captcha-title {
            font-size: 38px;
            font-family: PingFang SC;
            font-weight: bold;
            color: @fc1;
            text-align: center;
        }

        .captcha-image {
            width: 406px;
            height: 125px;
            border-radius: 10px;
            overflow: hidden;
            margin: 0 auto;
            margin-top: 66px;
            background-image: url('https://static.ndmicro.com/tmd/landing/images/code_bg.png');
            background-size: cover;

            canvas {
                width: 100%;
                height: 100%;
            }
        }

        .captcha-input {
            width: 406px;
            height: 94px;
            border: 1px solid rgba(170, 170, 170, 1);
            border-radius: 10px;
            margin: 0 auto;
            margin-top: 22px;
            padding-left: 25px;

            input {
                font-size: 46px;
                line-height: 60px;
                height: 60px;
                margin-top: 17px;
            }
        }

        .captcha-btn {
            width: 406px;
            height: 94px;
            line-height: 94px;
            border-radius: 10px;
            margin: 0 auto;
            margin-top: 65px;
            font-size: 40px;
            font-family: PingFang SC;
            font-weight: 600;
        }
    }
    .protocol-popup {
        background-color: transparent;
        dl {
            background-color: #fff;
            border-radius: 30px 30px 0px 0px;
            padding-bottom: 80px;
            dt {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 50px;
                height: 170px;
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                > img {
                    width: 33px;
                    height: 33px;
                }
            }
            dd {
                height: 110px;
                padding: 0 40px;
                line-height: 110px;
                font-size:30px;
                border-top: 1px solid #EEEEEE;
            }
        }
    }
}
</style>